import _sortBy from 'lodash/sortBy'
import _random from 'lodash/random'

/**
 * 设置title
 * @param title
 */
export const setTitle = function (title = '') {
    document.title = title;
};
/**
 * WX安卓输入框问题
 */
export const setMobileResize = function () {
    document.body.style.height = window.screen.availHeight +'px';
    window.addEventListener(
        "resize",() => {
          if (document.activeElement.tagName == "INPUT") {
            //延迟出现是因为有些 Android 手机键盘出现的比较慢   window.setTimeout(() => {
            document.activeElement.scrollIntoViewIfNeeded();
          }
        },
        100
      );
};

export const IsIOS=function(){
    var u = navigator.userAgent, app = navigator.appVersion;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    return isIOS;
}
/**
 * 判断是否是微信
 * @returns {boolean}
 */
export const isWeiXin = function () {
    let ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        return false;
    }
};

/**
 * 通过对象属性查找数组中的对象
 * @param array
 * @param objKey
 * @param value
 * @returns {*[]}
 */
export const findObjectInArray = function (array = [], objKey = '', value = '') {
    return array.filter(item => item[objKey] === value);
};

/**
 * lodash排序
 * @param arg1
 * @param arg2
 * @returns {*}
 */
export const sortBy = function (arg1, arg2) {
    return _sortBy(arg1, arg2);
};

export const random = function (...args) {
    return _random(...args);
};

/**
 * 获取hash参数列表
 * @returns {{}}
 */
export const getHashParameters = function () {
    const arr = (location.hash || "").replace(/#\/(\w*)(\?|\/\?)/, '').split("&");
    const params = {};
    let data = [];
    for (let i = 0; i < arr.length; i++) {
        data = arr[i].split("=");
        if (data.length === 2) {
            params[data[0]] = data[1];
        }
    }
    return params;
};

/**
 * 获取hash参数
 * @param key
 * @returns {*}
 */
export const getHashParameter = function (key) {
    return getHashParameters()[key];
};

export const getQueryFirst=function(){
    return (location.search || "").replace(/^\?/, '');
};
/**
 * 获取URL参数列表
 * @returns {{}}
 */
export const getUrlParameters = function () {
    const arr = (location.search || "").replace(/^\?/, '').split("&");
    const params = {};
    let data = [];
    for (let i = 0; i < arr.length; i++) {
        data = arr[i].split("=");
        if (data.length === 2) {
            params[data[0]] = data[1];
        }
    }
    return params;
};


/**
 * 获取URL参数
 * @param key
 * @returns {*}
 */
export const getUrlParameter = function (key) {
    return getUrlParameters()[key];
};

Array.prototype.findObjectInArray = function (objKey = '', value = '') {
    const array = this || [];
    return array.filter(item => item[objKey] === value);
};

export default {
    setTitle,
    isWeiXin,
    findObjectInArray,
    sortBy,
    getHashParameters,
    getHashParameter,
    getUrlParameter,
    getUrlParameters,
    getQueryFirst
}